<template>
  <!-- @submit.native.prevent -->
  <div id="rt-sass-grid" class="rt-sass-grid" @submit.prevent>
    <div v-show="showSearch" class="sass-grid_header">
      <div class="grid-icon">
        <rt-icon size="38" color="#fff" :name="iconName"></rt-icon>
      </div>
      <h2>{{ title }}</h2>
      <el-button
        v-if="$slots.more"
        type="text"
        class="grid-header_btn"
        @click="handleCollapse"
      >
        {{ $_t('更多筛选', 'BUTTON_MORESCREEN') }}
        <i :class="iconClass"></i>
      </el-button>
      <rt-search
        v-if="showQuick"
        v-model="quickSearch"
        class="grid-header_input"
        :placeholder="quicksearchPlaceholder"
        :more="false"
        @on-search="handleQuickSearch"
      />
      <!-- 按钮 -->
      <rt-sass-toolbar v-if="$slots.toolbar" class="grid-header_toolbar">
        <slot name="toolbar"></slot>
      </rt-sass-toolbar>
    </div>
    <div id="sass-grid_status" class="sass-grid_status">
      <slot name="status"></slot>
    </div>
    <div
      v-show="$slots.more && showHidden"
      id="saas-grid__moresearch"
      class="saas-grid__moresearch"
    >
      <slot name="more"></slot>
      <el-row :gutter="40" type="flex">
        <el-col :span="24" style="float: right; text-align: right">
          <el-button
            type="primary"
            class="saas-query__reset"
            @click="handleReset"
            >{{ $_t('重置', 'BUTTON_RESET') }}
          </el-button>
          <el-button type="primary" @click="handleSearch">{{
            $_t('确定', 'BUTTON_DETERMINE')
          }}</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="sass-grid__body">
      <slot></slot>
    </div>
    <div v-if="showPagination1" class="sass-grid__footer">
      <el-pagination
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :page-sizes="pageSizes"
        :layout="layout"
        :total="totalRecord"
        @size-change="handleSizeChange"
        @current-change="handleIndexChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RtSassGrid',
  props: {
    quicksearchPlaceholder: {
      type: String,
      default: function () {
        return this.$_t('请搜索...', 'common.plssearch'); // '请搜索...'
      }
    },
    showQuick: {
      type: Boolean,
      default: true,
      required: false
    },
    showPagination: {
      type: Boolean,
      default: true,
      required: false
    },
    totalRecord: {
      type: Number,
      required: false
    },
    defaultPageSize: {
      type: Number,
      required: false,
      default: 20
    },
    currentPageIndex: {
      type: Number,
      required: false,
      default: 1
    },
    currentPageSize: {
      type: Number,
      required: false
    },
    showSearch: {
      type: Boolean,
      required: false,
      default: true
    },
    title: {
      type: String,
      default: '',
      required: true
    },
    iconName: {
      type: String,
      required: false,
      default() {
        return 'rt-saas-servicelist';
      }
    },
    isPagination: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  data() {
    return {
      quickSearch: null,
      pageIndex: this.currentPageIndex,
      showHidden: false,
      pageSize: this.defaultPageSize,
      layout: 'total, sizes, prev, pager, next, jumper',
      pageSizes: [10, 20, 30, 40, 50],
      showPagination1: false
    };
  },
  computed: {
    iconClass() {
      return this.showHidden ? 'el-icon-arrow-up' : 'el-icon-arrow-down';
    }
  },

  watch: {
    currentPageIndex(val, oldValue) {
      if (this.pageIndex != val) {
        this.handleIndexChange(val);
      }
    },
    currentPageSize(val) {
      this.pageSize = val;
    }
  },
  mounted() {
    this.resetTableheight();
    this.$nextTick(() => {
      this.showPagination1 = this.showPagination;
    });
  },
  methods: {
    resetTableheight() {
      this.$nextTick(() => {
        var tableHeight = document.body.clientHeight - 250;
        var moreHeight = document.getElementById('saas-grid__moresearch')
          ? document.getElementById('saas-grid__moresearch').clientHeight
          : 0;
        var statusHeight = document.getElementById('sass-grid_status')
          ? document.getElementById('sass-grid_status').clientHeight
          : 0;
        this.$store.commit(
          'UPDATE_TABLE_HEIGHT',
          tableHeight - moreHeight - statusHeight
        );
      });
    },
    handleCollapse() {
      this.showHidden = !this.showHidden;
      this.$nextTick(() => {
        var tableHeight = document.body.clientHeight - 200;
        var moreHeight = document.getElementById('saas-grid__moresearch')
          ? document.getElementById('saas-grid__moresearch').clientHeight
          : 0;
        var statusHeight = document.getElementById('sass-grid_status')
          ? document.getElementById('sass-grid_status').clientHeight
          : 0;
        this.$store.commit(
          'UPDATE_TABLE_HEIGHT',
          tableHeight - moreHeight - statusHeight
        );
      });
    },

    handleReset() {
      this.$emit('reset');
    },
    handleSearch() {
      this.pageIndex = 1;
      this.$emit('search');
    },

    handleQuickSearch() {
      this.pageIndex = 1;
      this.$emit('quick-search');
    },

    handleQuickSearchFromInput() {
      this.handleQuickSearch();
    },

    handleSizeChange(val) {
      //
      this.pageSize = val;
      this.$emit('page-change');
    },
    handleIndexChange(val) {
      //
      this.pageIndex = val;
      this.$emit('page-change');
    },

    getPageIndex() {
      return this.pageIndex;
    },
    getPageSize() {
      return this.pageSize;
    },
    getSearchString() {
      return this.quickSearch;
    },
    setSearchString(quicksearch) {
      this.quickSearch = quicksearch;
    },
    resetPageIndex() {
      this.pageIndex = 1;
    }
  }
};
</script>
<style scoped lang="less">
@import './saas.css'; // todo  这个需要被干掉
.rt-sass-grid {
  margin-top: 10px;
}

/* 头部 */
.sass-grid_header {
  position: relative;
  box-sizing: border-box;
  height: 80px;
  padding: 15px;
  overflow: hidden;
  background: #fff;
}

.sass-grid_header h2 {
  float: left;
  margin-top: 15px;
  margin-left: 20px;
  font-size: 18px;
  color: #294060;
}

/* icon 图标 */
.grid-icon {
  float: left;
  width: 50px;
  height: 50px;
  text-align: center;
  background: #ff992c;
  border-radius: 2px;
}

.grid-icon .rt-icon {
  margin-top: 6px;
}

/* 更多筛选按钮 */
.grid-header_btn {
  float: right;
  padding: 0;
  margin: 18px 0 0 10px;
}

.grid-header_btn i {
  font-size: 10px;
  font-weight: bold;
}

/* 快速搜索 */
.grid-header_input {
  float: right;
  width: 20%;
  margin-top: 8.5px;
  margin-left: 15px;
}

.grid-header_input .rt-icon {
  margin-top: 10px;
  cursor: pointer;
}

/* 头部按钮 */
.grid-header_toolbar {
  margin-top: 10px;
}

/* 状态信息 */
.sass-grid_status {
  display: flex;
  overflow: hidden;
  background: #fff;
}

/* 重置按钮样式 */
.saas-query__reset {
  color: #557ab4;
  background-color: #fff;
  border-color: #b4bdcf;
}

.saas-query__reset:hover {
  color: #557ab4;
  background-color: #fff;
  border-color: #b4bdcf;
}

.saas-query__reset:focus {
  color: #557ab4;
  background-color: #fff;
  border-color: #b4bdcf;
}

.rt-sass-grid .el-button--primary {
  height: 30px;
  border-radius: 2px;
}

/* 更多筛选表单 */
.saas-grid__moresearch {
  padding: 20px 15px;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  border-bottom: none;

.rt-saas-lookup .rt-icon {
    margin-top: 10px;
  }

.el-input__icon {
    line-height: 34px !important;
  }
}

/* 重置和查询 */
.sass-grid__footer {
  padding: 0;
  // margin: 0 5px;
  background-color: #fff;
}

/* 分页 */
.rt-sass-grid .el-pagination {
  padding: 20px 0 !important;
  text-align: center;
  background: transparent;
  border-top: 1px solid #f0f0f0;
}

.rt-sass-grid .el-pagination-reset {
  border-top: none;
}
</style>

<style lang="scss">
.rt-sass-grid {
  /* 更多筛选按钮 */
  .grid-header_btn {
    color: #0073e6;
  }
  .grid-header_btn i {
    color: #0073e6;
  }
  .el-table td {
    color: #0b0c0e;
    cursor: pointer;
  }
  .el-table th > .cell {
    color: #363d44;
    font-weight: 550;
  }
}
</style>



// WEBPACK FOOTER //
// main.vue?42616d59